// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.categories-filter-modal {
  display: flex;
  flex-direction: column;
  padding: 0 var(--space-md) var(--space-md);
}
.categories-filter-modal .subtitle {
  padding: var(--space-xl) var(--space-md) var(--space-lg);
  color: var(--color-grey-500);
  font-size: var(--font-heading-section-size);
  font-style: normal;
  font-weight: 500;
  line-height: var(--type-line-height-heading-h2);
}

.categories-list {
  margin-top: var(--space-lg);
  display: flex;
  flex-direction: column;
  gap: var(--space-sm);
}

.confirm-container {
  padding: var(--space-md);
  border-top: 1px solid var(--color-grey-200);
  display: flex;
  gap: var(--space-sm);
}
.confirm-container flw-button {
  flex: 1;
}
.confirm-container flw-button flw-icon {
  --cursor: pointer;
}
.confirm-container flw-button.disabled flw-icon {
  --cursor: default;
}
.confirm-container .clear-filters-btn {
  flex: 0 0 auto;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/categories-filter-modal/categories-filter-modal.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,0CAAA;AACJ;AACE;EACE,wDAAA;EAEA,4BAAA;EAEA,2CAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;AADJ;;AAKA;EACI,2BAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;AAFJ;;AAKA;EACI,wBAAA;EACA,2CAAA;EACA,aAAA;EACA,oBAAA;AAFJ;AAII;EACI,OAAA;AAFR;AAIQ;EACE,iBAAA;AAFV;AAKQ;EACE,iBAAA;AAHV;AAOI;EACI,cAAA;AALR","sourcesContent":[".categories-filter-modal {\r\n    display: flex;\r\n    flex-direction: column;\r\n    padding: 0 var(--space-md) var(--space-md);\r\n\r\n  .subtitle {\r\n    padding: var(--space-xl) var(--space-md) var(--space-lg);\r\n\r\n    color: var(--color-grey-500);\r\n\r\n    font-size: var(--font-heading-section-size);\r\n    font-style: normal;\r\n    font-weight: 500;\r\n    line-height: var(--type-line-height-heading-h2);\r\n  }\r\n}\r\n\r\n.categories-list {\r\n    margin-top: var(--space-lg);\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: var(--space-sm);\r\n}\r\n\r\n.confirm-container {\r\n    padding: var(--space-md);\r\n    border-top: 1px solid var(--color-grey-200);\r\n    display: flex;\r\n    gap: var(--space-sm);\r\n\r\n    flw-button {\r\n        flex: 1;\r\n\r\n        flw-icon {\r\n          --cursor: pointer;\r\n        }\r\n\r\n        &.disabled flw-icon {\r\n          --cursor: default;\r\n        }\r\n    }\r\n\r\n    .clear-filters-btn {\r\n        flex: 0 0 auto;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
